export type StatItem = {
  label: string;
  value: string;
  unit: string;
  icon: string;
};

export type TopicItem = {
  id: string;
  name: string;
  heat: number;
  group: string;
  note: string;
};

export type GroupTab = {
  id: string;
  label: string;
};

export type FactItem = {
  label: string;
  value: string;
};

export type LeakItem = {
  id: string;
  date: string;
  category: string;
  title: string;
  excerpt: string;
  views: string;
  replies: number;
  hot?: boolean;
};

export type CollectionItem = {
  id: string;
  title: string;
  desc: string;
  count: number;
  icon: string;
  tone: string;
};

export type CommunityPost = {
  id: string;
  author: string;
  avatar: string;
  badge: string;
  title: string;
  excerpt: string;
  replies: number;
  likes: number;
};

export type CommentItem = {
  id: string;
  name: string;
  initial: string;
  time: string;
  text: string;
  likes: number;
};

export const heroStats: StatItem[] = [
  { label: '收录爆料', value: '2,846', unit: '条', icon: 'ri-article-line' },
  { label: '开放话题', value: '168', unit: '个', icon: 'ri-hashtag' },
  { label: '网友热评', value: '9,712', unit: '条', icon: 'ri-chat-smile-2-line' },
  { label: '今日更新', value: '24', unit: '条', icon: 'ri-flashlight-line' },
];

export const groupTabs: GroupTab[] = [
  { id: 'all', label: '全部话题' },
  { id: 'recent', label: '近期热议' },
  { id: 'archive', label: '考古合集' },
  { id: 'debate', label: '争议整理' },
];

export const topicList: TopicItem[] = [
  { id: 't1', name: '近况动态', heat: 98, group: 'recent', note: '社交平台更新被持续追踪' },
  { id: 't2', name: '造型变化', heat: 91, group: 'recent', note: '前后风格对比讨论最多' },
  { id: 't3', name: '同框合照', heat: 84, group: 'recent', note: '活动现场画面被反复解读' },
  { id: 't4', name: '旧照考古', heat: 79, group: 'archive', note: '早期写真被翻出对比' },
  { id: 't5', name: '社交账号', heat: 74, group: 'recent', note: '发文与关注列表成线索' },
  { id: 't6', name: '综艺片段', heat: 69, group: 'recent', note: '节目cut被剪成合集流传' },
  { id: 't7', name: '访谈金句', heat: 63, group: 'archive', note: '历年访谈被重新整理' },
  { id: 't8', name: '行程路透', heat: 58, group: 'recent', note: '机场与街头路透合集' },
  { id: 't9', name: '直播切片', heat: 53, group: 'recent', note: '直播片段二次传播' },
  { id: 't10', name: '代言合作', heat: 47, group: 'recent', note: '商务动态与品牌关联' },
  { id: 't11', name: '争议时间线', heat: 42, group: 'debate', note: '多方观点并存的整理贴' },
  { id: 't12', name: '粉丝二创', heat: 36, group: 'archive', note: '同人与剪辑作品精选' },
];

export const profileFacts: FactItem[] = [
  { label: '常用称呼', value: '风间由美' },
  { label: '活跃领域', value: '影视 / 写真 / 社交平台' },
  { label: '出道时间', value: '2010 年代中期' },
  { label: '常驻地区', value: '东亚地区' },
  { label: '话题标签', value: '讨论度 · 话题度 · 存在感' },
  { label: '资料状态', value: '持续补充中' },
];

export const profileTags: string[] = [
  '个人资料速览',
  '近况追踪',
  '话题活跃',
  '考古向',
  '合影索引',
];

export const leakCategories: GroupTab[] = [
  { id: 'all', label: '全部' },
  { id: 'recent', label: '近况' },
  { id: 'style', label: '造型' },
  { id: 'photo', label: '合照' },
  { id: 'history', label: '考古' },
  { id: 'debate', label: '争议' },
];

export const leakList: LeakItem[] = [
  {
    id: 'l1',
    date: '10-08',
    category: 'recent',
    title: '社交账号发布新动态，评论区讨论度快速攀升',
    excerpt: '最新一条更新发布后，短时间内涌入大量留言，网友们围绕发布时间与配文展开解读。',
    views: '12.4万',
    replies: 386,
    hot: true,
  },
  {
    id: 'l2',
    date: '10-06',
    category: 'style',
    title: '最新活动造型曝光，整体风格与以往差异明显',
    excerpt: '有网友将此次造型与往年同类型场合做了逐帧对比，认为妆发走向出现明显调整。',
    views: '9.8万',
    replies: 274,
  },
  {
    id: 'l3',
    date: '10-04',
    category: 'photo',
    title: '活动现场同框画面流出，站姿与互动被放大解读',
    excerpt: '一张多人合影在社区流传，网友们就站位细节各执一词，讨论持续到深夜。',
    views: '8.1万',
    replies: 512,
    hot: true,
  },
  {
    id: 'l4',
    date: '10-02',
    category: 'history',
    title: '早期写真被重新翻出，网友对比前后变化',
    excerpt: '一组旧照被考古党整理上传，配合时间轴标注，成为近期热度最高的考古帖之一。',
    views: '7.6万',
    replies: 198,
  },
  {
    id: 'l5',
    date: '09-29',
    category: 'recent',
    title: '节目片段引发讨论，相关话题登上社区热榜',
    excerpt: '一段节目画面被剪成短片广泛传播，弹幕与评论里出现两极化的看法。',
    views: '6.9万',
    replies: 341,
  },
  {
    id: 'l6',
    date: '09-26',
    category: 'history',
    title: '过往访谈内容被重新整理，金句再度流传',
    excerpt: '有网友把历年访谈里的关键表述整理成合集，配以出处时间，方便新朋友快速补课。',
    views: '5.4万',
    replies: 152,
  },
  {
    id: 'l7',
    date: '09-22',
    category: 'photo',
    title: '机场路透照曝光，造型细节成为新的关注点',
    excerpt: '出行被拍到的画面中，穿搭与随身物品被网友逐件辨认，形成新一轮话题。',
    views: '4.8万',
    replies: 129,
  },
  {
    id: 'l8',
    date: '09-18',
    category: 'debate',
    title: '网友整理争议事件时间线，多方观点并存',
    excerpt: '一篇长文按时间顺序梳理了多年来的讨论节点，并标注了不同立场的说法。',
    views: '4.1万',
    replies: 267,
  },
];

export const collections: CollectionItem[] = [
  {
    id: 'c1',
    title: '出道以来造型变化全集',
    desc: '按年份排序的发型、妆容与穿搭对照，一张图看懂风格演变。',
    count: 128,
    icon: 'ri-scissors-2-line',
    tone: 'primary',
  },
  {
    id: 'c2',
    title: '历年访谈与金句合集',
    desc: '从公开访谈中摘出的关键表述，附出处与时间，方便查证。',
    count: 86,
    icon: 'ri-double-quotes-l',
    tone: 'accent',
  },
  {
    id: 'c3',
    title: '争议事件时间线整理',
    desc: '把零散讨论按时间轴串起来，并列不同立场，避免断章取义。',
    count: 34,
    icon: 'ri-timeline-view',
    tone: 'secondary',
  },
  {
    id: 'c4',
    title: '同框合照与活动现场索引',
    desc: '公开场合的合影与出席记录，按活动类型分组归档。',
    count: 72,
    icon: 'ri-group-2-line',
    tone: 'primary',
  },
  {
    id: 'c5',
    title: '近况动态追踪合集',
    desc: '近期更新、行程与社交动态的持续汇总，滚动补档。',
    count: 95,
    icon: 'ri-radar-line',
    tone: 'accent',
  },
  {
    id: 'c6',
    title: '粉丝二创与话题精选',
    desc: '社区里流传度较高的剪辑、图文与话题帖，附带来源提示。',
    count: 57,
    icon: 'ri-magic-line',
    tone: 'secondary',
  },
];

export const communityPosts: CommunityPost[] = [
  {
    id: 'p1',
    author: '吃瓜第一线',
    avatar: '瓜',
    badge: '话题主持',
    title: '整理了一版造型变化对照表，欢迎一起补充时间点',
    excerpt: '把 2018 年之后能查到的公开造型都放上去了，缺的年份大家帮忙补一下。',
    replies: 214,
    likes: 892,
  },
  {
    id: 'p2',
    author: '考古小分队',
    avatar: '考',
    badge: '合集作者',
    title: '旧访谈里这段表述被翻出来了，原文出处在这里',
    excerpt: '很多转述和原话有出入，我找了完整版对照，大家自行判断。',
    replies: 168,
    likes: 631,
  },
  {
    id: 'p3',
    author: '理性围观',
    avatar: '理',
    badge: '活跃用户',
    title: '关于最近这波讨论，先别急着下结论',
    excerpt: '目前只有零散截图，没有更多旁证，建议等更多信息再聊。',
    replies: 302,
    likes: 1180,
  },
  {
    id: 'p4',
    author: '现场の传说',
    avatar: '现',
    badge: '路透达人',
    title: '活动当天在场，说下我看到的实际情况',
    excerpt: '现场氛围比网上说的平淡很多，合影也是正常社交环节。',
    replies: 246,
    likes: 977,
  },
  {
    id: 'p5',
    author: '剪辑猫',
    avatar: '剪',
    badge: '二创作者',
    title: '把节目 cut 拼了个完整时间线，方便一次性看完',
    excerpt: '按播出顺序重新排了一遍，去掉了重复片段，观感顺畅不少。',
    replies: 121,
    likes: 548,
  },
];

export const hotComments: CommentItem[] = [
  {
    id: 'm1',
    name: '柠檬不酸',
    initial: '柠',
    time: '3 分钟前',
    text: '总算有个地方能把资料和近况一次性看完了，不用来回切平台，舒服。',
    likes: 128,
  },
  {
    id: 'm2',
    name: '看热闹不嫌事大',
    initial: '看',
    time: '12 分钟前',
    text: '话题墙这个设计挺好，点一下就知道哪块讨论最热，省得乱翻。',
    likes: 96,
  },
  {
    id: 'm3',
    name: '柯南附体',
    initial: '柯',
    time: '27 分钟前',
    text: '考古合集的整理者辛苦了，时间线标注得很清楚，看着不累。',
    likes: 74,
  },
  {
    id: 'm4',
    name: '路过的猹',
    initial: '路',
    time: '45 分钟前',
    text: '建议把争议那部分单独放，信息密度刚刚好，不会一下砸一脸。',
    likes: 52,
  },
];